export class CreateFournisseurAgree
{
    marcheId: number;
    codeClient: String;
    numeroRct:String;
    nomComplet:String;
    limiteAutorisee:number;
}